import { View } from "../../../../core/view/index";
import { Template } from "../../../../core/template/index";
import AppIcons from "../../../icons";
import { ShelveItemView } from "./partials/shelve_item/index";
import { ClientAction } from "../../../synchronizer/index";


export class ShelvePackagesView extends View {

    template = Template.lazy('/app/views/package_tracking/receive/shelve_packages.html');
    itemList: HTMLOListElement;
    confirmButton: HTMLButtonElement;

    renderedItems: ShelveItemView[] = [];

    public beforeRender(): PromiseLike<any>
    {
        this.app.header.text = this.pgettext('Title', 'Shelve packages');
        this.app.header.iconClass = AppIcons.PackageTracking;
        if (this.data.items && this.data.items.length > 0) {
            return super.beforeRender();
        } else {
            history.back();
            return Promise.reject(new Error('Missing items'));
        }
    }

    public afterRender(): PromiseLike<any>
    {
        return this.populateList(this.data.items);
    }

    private onStatusChanged()
    {
        if(!this.renderedItems.some(item => {
            return !item.data.shelf;
        })) {
            this.confirmButton.disabled = false;
        } else {
            this.confirmButton.disabled = true;
        }
    }

    private populateList(items): PromiseLike<any>
    {
        return Promise.all(items.reverse().map(item => {
            let shelveItemView = new ShelveItemView(item);
            this.renderedItems.push(shelveItemView);
            shelveItemView.on('shelved', this.onStatusChanged.bind(this));
            return this.app.renderPartialView(shelveItemView, this.itemList);
        }));
    }

    private onConfirmClicked() {
        
        this.helpers.setButtonEnabled(this.confirmButton, false);
        let promises = [];
        this.renderedItems.forEach(item => {
            console.log(item);

            let receiveMessage = {
                id: parseInt(item.data.id),
                quantity: parseFloat(item.data.quantity),
                shipment_number: item.data.shipment_number,
                waybill: item.data.waybill,
                weight: parseFloat(item.data.weight),
                weight_unit: item.data.weight_unit,
                work_order: item.data.work_order
            };

            let shelveMessage = {
                id: parseInt(item.data.id),
                shelf: item.data.shelf
            };

            let promises = [];
            promises.push(this.app.synchronizer.push({
                action: ClientAction.PACKAGE_TRACKING.RECEIVE_PACKAGE,
                data: receiveMessage
            }, false));

            promises.push(this.app.synchronizer.push({
                action: ClientAction.PACKAGE_TRACKING.SHELVE_PACKAGE,
                data: shelveMessage
            }));
        });

        Promise.all(promises).then(() => {
            this.app.toasts.show(this.pgettext('Message', 'Packages received successfully'));
            history.go(-2);
        });
    }

}